import { getAssetRisk, getAssetRiskHistory } from '@Actions/assetRisk.actions';
import { CircularProgress, Grid, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Overall } from '../Overall';
import { RiskComponents } from '../RiskComponents';
import { Trend } from '../Trend';
import { usePanelStyles } from './RiskModelTabPanel.styles';
import {
	selectAssetRisk,
	selectAssetRiskIsReady,
} from '@Selectors/assetRisk.selectors';
import {
	selectAssetRiskHistory,
	selectAssetRiskHistoryIsReady,
} from '@Selectors/assetRiskHistory.selectors';
import { RiskIcon } from '../RiskIcon.component';
import { useGlobalization } from '@Translations/useGlobalization';

export const RiskModelTabPanel = (props: {
	activeTab: number;
	index: number;
	assetId: string;
	assetType: string;
	configId: string;
}): JSX.Element => {
	const { activeTab, index, assetId, assetType, configId } = props;
	const { t } = useGlobalization();

	const classes = usePanelStyles();
	const assetRisk = selectAssetRisk();
	const isAssetRiskReady = selectAssetRiskIsReady();
	const assetRiskHistory = selectAssetRiskHistory();
	const isAssetRiskHistoryReady = selectAssetRiskHistoryIsReady();
	const dispatch = useDispatch();

	useEffect(() => {
		if (activeTab === index) {
			dispatch(
				getAssetRisk({
					assetId: assetId,
					assetType: assetType,
					configId: configId,
				}),
			);
			dispatch(
				getAssetRiskHistory({
					assetId: assetId,
					assetType: assetType,
					configId: configId,
				}),
			);
		}
	}, [activeTab]);

	return (
		<div
			className={classes.root}
			role="tabpanel"
			hidden={activeTab !== index}
			id={`vertical-tabpanel-${index}`}
			aria-labelledby={`vertical-tab-${index}`}>
			{activeTab === index && (
				<div>
					{isAssetRiskHistoryReady && isAssetRiskReady ? (
						assetRisk?.ASSET_ID && assetRiskHistory?.length ? (
							<Grid container>
								<Grid item xs={12}>
									<Overall orientation="horizontal" />
								</Grid>
								<Grid item xs={12}>
									<RiskComponents />
								</Grid>
								<Grid item xs={12}>
									<Trend />
								</Grid>
							</Grid>
						) : (
							<div>
								<Grid
									container
									item
									xs={12}
									justifyContent="center">
									<RiskIcon />
								</Grid>
								<Grid
									container
									item
									xs={12}
									justifyContent="center">
									<Typography variant="h6">
										{t('Asset not included in risk model')}
									</Typography>
								</Grid>
								<Grid
									container
									item
									xs={12}
									justifyContent="center">
									<Typography variant="caption">
										{t(
											'This can happen due to filtering criteria.',
										)}
									</Typography>
								</Grid>
							</div>
						)
					) : (
						<CircularProgress />
					)}
				</div>
			)}
		</div>
	);
};
